import { action } from '@storybook/addon-actions';
import * as React from 'react';

import { NewAnalyticsContext } from './new-analytics-context';

export const createStorybookAnalyticsClient = () => ({
  sendUIEvent: action('[Analytics.sendUIEvent]'),
  sendScreenEvent: action('[Analytics.sendScreenEvent]'),
  sendTrackEvent: action('[Analytics.sendTrackEvent]'),
  sendOperationalEvent: action('[Analytics.sendOperationalEvent]'),
  init: () => null,
  initOriginTracingHandlers: () => null,
  setOrgId: () => null,
  getAnalyticsWebClient: action('[Analytics.getAnalyticsWebClient]'),
});

export class StorybookAnalyticsClientProvider extends React.Component<React.PropsWithChildren<{}>> {
  private newAnalyticsClient = createStorybookAnalyticsClient();

  public render() {
    return <NewAnalyticsContext.Provider value={this.newAnalyticsClient}>{this.props.children}</NewAnalyticsContext.Provider>;
  }
}
